var map = {
	"./2-1.jpg": "5ace",
	"./cm.jpg": "fdf9",
	"./juggernaut.jpg": "fbda",
	"./lc.jpg": "02b8",
	"./lina.jpg": "33d0",
	"./monkey-king.jpg": "1c16",
	"./ogre.jpg": "5c11",
	"./phantom-assasin.jpg": "45c3",
	"./pudge.jpg": "0103",
	"./rubick.jpg": "7994",
	"./sf.jpg": "545d",
	"./techies.jpg": "c05d",
	"./terror-blade.jpg": "9fde",
	"./zeus.jpg": "3aed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7898";